<!------------ START TEMPLATE ------------>
<template>
  <div
    v-if="exibir == true"
    id="data-list-list-view"
    class="data-list-container"
  >
    <vs-alert
      v-if="itens.length > 0"
      color="primary"
      title="Consolidado"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      Quantidade de Cobranças: {{ qtdCobrancas }} <br />
      Valor Total: {{ valorTotal | currency }}
    </vs-alert>
    <vs-table
      noDataText="Nenhuma Registro Encontrado"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES ------------>

          <!------------ END MENU DE AÇÕES ------------>

          <!------------ START ADD NOVO Tipo Pagamento ------------>
        </div>
        <!------------ END ADD NOVO Tipo Pagamento ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ paginaAtual * itemsPerPage - (itemsPerPage - 1) }} -
              {{ itens.length }} de {{ qtdTotal }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="id">#</vs-th>
        <vs-th sort-key="id_associado">Beneficiário</vs-th>
        <vs-th sort-key="placa">Veículo</vs-th>
        <vs-th sort-key="forma_pagamento">Forma de Pagamento</vs-th>
        <vs-th sort-key="tipo_boleto">Tipo</vs-th>
        <vs-th sort-key="data_vencimento">Data Vencimento</vs-th>
        <vs-th sort-key="data_emissao">Data Emissão</vs-th>
        <vs-th sort-key="valor_boleto">Valor</vs-th>
        <vs-th sort-key="situacao_boleto">Status</vs-th>
        <vs-th sort-key="boletoFisico">Físico</vs-th>
        <vs-th sort-key="regional">Regional</vs-th>
        <vs-th sort-key="consultor">Consultor</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.id }} - {{ tr.origem }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{ tr.associado }}
                <router-link
                  target="_blank"
                  :to="`/DetalheAssociado/${tr.id_associado}`"
                >
                  <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
                </router-link>
              </p>
              <p class="product-category">{{ tr.cpfcnpj }}</p>
              <p class="product-category">{{ tr.statusAssociado }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.placa }}</p>
              <p class="product-category">{{ tr.chassi }}</p>
              <p class="product-category">{{ tr.statusVeiculo }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.forma_pagamento }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.tipo_boleto }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{ formataDataUTC(tr.data_vencimento) }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{ formataDataUTC(tr.data_emissao) }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.valor_boleto | currency }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.situacao_boleto }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ formataBoletoFisico(tr) }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.regional }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.consultor }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination :total="qtdPaginas" v-model="paginaAtual"></vs-pagination>

    <!------------ END TABELA ------------>

    <!------------ START INFORMAÇÕES DO Setor ------------>

    <vs-popup
      class="holamundo"
      :active.sync="popupActive"
      :title="`Editar Contrato`"
      @close="popupActive = false"
    >
      <form role="form" @submit.stop.prevent="onSubmit">
        <quill-editor v-model="modalSelecionado.modeloContrato"></quill-editor>
        <vs-button color="success" class="mb-2 my-5">
          <span>Atualizar</span>
        </vs-button>
      </form>
    </vs-popup>
    <!------------ END INFORMAÇÕES DO Setor ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import service from '../../services';
import moment from 'moment';
import { quillEditor } from 'vue-quill-editor';

// require styles
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  components: {
    quillEditor,
  },
  props: ['filtro', 'realizaFiltro', 'vistoria', 'subjectPermission'],
  watch: {
    realizaFiltro: function (newValue, oldValue) {
      if (newValue == true) {
        console.log(this.filtro);
        this.buscaDados();
        this.$emit('filtroOk', true);
      }
    },
    paginaAtual: function (newValue, oldValue) {
      console.log(this.paginaAtual);
      this.buscaDados();
    },
    itemsPerPage: function (newValue, oldValue) {
      console.log(this.itemsPerPage);
      this.buscaDados();
    },
  },
  data() {
    return {
      idEmpresa: null,
      dadosSideBar: {},
      popupActive: false,
      modalSelecionado: [],
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 25,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      qtdCobrancas: 0,
      valorTotal: 0,
      isMounted: false,
      addNewDataSidebar: false,
      exibir: false,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    formataBoletoFisico(obj) {
      if (obj.forma_pagamento == 'Boleto') {
        return obj.boletoFisico == 1 ? 'Sim' : 'Não';
      } else return '--';
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY');
    },
    buscaDados() {
      this.selected = [];
      var objSend = {};
      if (this.filtro) {
        objSend = { ...this.filtro };
        objSend.dataInicial = moment(this.filtro.dataInicial).format(
          'YYYY-MM-DD',
        );
        objSend.dataFinal = moment(this.filtro.dataFinal).format('YYYY-MM-DD');
      } else {
        objSend.tipoData = 'Data Cadastro';
        objSend.dataInicial = moment().add(-1, 'days').format('YYYY-MM-DD');
        objSend.dataFinal = moment().format('YYYY-MM-DD');
      }

      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;

      this.$vs.loading();
      service
        .post('Financeiro', 'PainelFinanceiro', objSend)
        .then((res) => {
          this.exibir = true;
          this.itens = [];
          this.qtdTotal = res.data.qtd;
          this.qtdPaginas = this.qtdTotal / this.itemsPerPage;

          if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
          this.qtdPaginas = parseInt(this.qtdPaginas);

          if (this.qtdTotal > 0) {
            res.data.registros.forEach((element) => {
              this.itens.push(element);
            });
          }

          this.qtdCobrancas = this.qtdTotal;
          this.valorTotal = res.data.valorTotal;

          this.$vs.loading.close();
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    openSideBar(dados) {
      dados.idModelo == null
        ? (this.titleSideBar = `Adicionar Tipo de Pagamento `)
        : (this.titleSideBar = `Editar dados do Tipo de Pagamento`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    opemModal(dados) {
      this.modalSelecionado = dados;
      this.popupActive = true;
    },
    concluido() {
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == null) return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
  },
  created() {
    //this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<!------------ END STYLE ------------>
